import { COMPLIANCE_MESSAGE_CLOSED_KEY } from './Teasers.constants';

export const resetSessionStorageComplianceConsents = () => {
    Object.keys(sessionStorage)
        .filter((key) => {
            const pattern = new RegExp(COMPLIANCE_MESSAGE_CLOSED_KEY);
            return pattern.test(key);
        })
        .forEach((key) => {
            sessionStorage.removeItem(key);
        });
};
